import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheMainStage from "./sections/TheMainStage";
import TheArsenal from "./sections/TheArsenal";
import StudioEthos from "./sections/StudioEthos";
import InTheThickOfIt from "./sections/InTheThickOfIt";
import GrabTheSchedule from "./sections/GrabTheSchedule";
import LockInYourSlot from "./sections/LockInYourSlot";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheMainStage />
      <TheArsenal />
      <StudioEthos />
      <InTheThickOfIt />
      <GrabTheSchedule />
      <LockInYourSlot />
      <Footer />
    </div>;
}